export default "__VITE_ASSET__Chd5duq6__"